import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import { INITIAL_PAGING, STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from "myParkdUtils/constants";
import { PagingReactTable, SessionDTOExtended, Status } from "types";


export type ActiveSessionsState = {
    sessions: SessionDTOExtended[];
    paging: PagingReactTable;
    status: Status
};

export const initialState: ActiveSessionsState = {
    sessions: [],
    paging: INITIAL_PAGING,
    status: STATUS_INITIAL
};

export const activeSessionsSlice = createSlice({
    name: 'activeSessions',
    initialState,
    reducers: {
        getActiveSessions(state, action: PayloadAction<{ paging: PagingReactTable, filters?: ColumnFilter[], sorting?: ColumnSort[] }>) {
            state.status = STATUS_LOADING;
            state.sessions = [];
            state.paging.currentPage = action.payload.paging.currentPage;
            state.paging.pageSize = action.payload.paging.pageSize;
        },
        getActiveSessionsCompleted(state, action: PayloadAction<{ sessions: SessionDTOExtended[], totalElements: number, totalPages: number }>) {
            state.status = STATUS_SUCCEEDED;
            state.sessions = action.payload.sessions;
            state.paging.totalElements = action.payload.totalElements;
            state.paging.totalPages = action.payload.totalPages;
        },
        getActiveSessionsError(state, action: PayloadAction<{ error: any }>) {
            state.status = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        }
    }
});

export const activeSessionsSliceActions = activeSessionsSlice.actions;

export default activeSessionsSlice.reducer;